import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/BarFooter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BarTop.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BtnScrollToId.jsx");
